module.exports = __webpack_public_path__ + "img/form-line.5b9005ca.svg";